var render = function render(){var _vm=this,_c=_vm._self._c;return _c('mall-fixed-bar',{staticClass:"mall-fixed-button-bar"},[(_vm.text)?_c('button',{staticClass:"mall-fixed-button-bar__button",attrs:{"type":"button"},on:{"click":_vm.handleClick}},[_vm._v("\n    "+_vm._s(_vm.text)+"\n  ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }